import React from "react"
import { Pagination } from "react-admin"


export default function DefaultPagination (props: Record<string, unknown>) {
  return (
    <Pagination {...props} rowsPerPageOptions={[15, 25, 50, 100, 200]} />
  )
}
